import type { SitScheduleRow } from "../../domain/defensePresentation";
import { SectionCard } from "../../shared/ui/section-card";

export function DefenseSitSchedule({ rows }: { rows: SitScheduleRow[] }) {
  return (
    <SectionCard title="SIT SCHEDULE" contentClassName="pt-1">
      <div className="grid grid-cols-2 gap-x-3 gap-y-1 sm:grid-cols-3">
        {rows.map(({ player, innings, label }) => (
          <div
            key={player.id}
            className={
              innings.length
                ? "flex min-w-0 items-center justify-between gap-2 rounded px-1.5 py-1 text-sm"
                : "flex min-w-0 items-center justify-between gap-2 rounded bg-background/60 px-1.5 py-1 text-sm"
            }
          >
            <span className="truncate">{player.name}</span>
            <span
              className={
                innings.length
                  ? "shrink-0 font-mono text-xs text-danger"
                  : "shrink-0 font-mono text-xs text-warning"
              }
            >
              {label}
            </span>
          </div>
        ))}
      </div>
    </SectionCard>
  );
}
